// composables/useLoading.ts
export const useDownLoadLoading = () => {
  const isDownLoadLoading = useState<boolean>('downloadLoading', () => false)
  const progress = useState<number>('downloadProgress', () => 0)

  const setProgress = (value: number) => {
    if (value < 0 || value > 100) {
      console.warn('Progress value must be between 0 and 100')
      return
    }
    progress.value = value
  }

  const downShow = () => {
    isDownLoadLoading.value = true
    progress.value = 0
  }

  const downHide = () => {
    isDownLoadLoading.value = false
  }

  return {
    isDownLoadLoading,
    progress,
    downShow,
    downHide,
    setProgress,
  }
}
